const INITIAL_STATE = {
  step: 2,
  name: null,
  document: null,
  organizationId: null,
  phoneDdd: null,
  phoneNumber: null,
  email: null,
  birthdate: null,
  address: null,
  condominiumIdSf: null,
  blockIdSf: null,
  unit: {},
  hasGasMeter: null,
  dueDay: null,
  password: null,
  confirmPassword: null,
  location: null,
  condoCode: null,
  condoZipCode: null,
  condominiumByZipCode: null,
  condominiumByCode: null,
  typeSelector: "cep",
  digitalInvoice: null,
  digitalInvoiceEmail: null,
  digitalInvoiceEmailId: null,
  automaticDebit: null,
  agencyNumber: null,
  accountNumber: null,
  bank: null,
  cardDocument: null,
  accountOwnerName: null,
  awsCustomerId: null,
};

const membershipReducer = (state = INITIAL_STATE, action) => {
  const { type } = action;

  const reducer = {
    TOGGLE_MEMBERSHIP_STEP: () => ({ ...state, step: action.step }),
    MEMBERSHIP_VALUES: () => ({ ...state, ...action.object }),
    MEMBERSHIP_UNIT: () => ({
      ...state,
      unit: { ...state.unit, ...action.object }
    }),
    RESET_STATE_MEMBERSHIP: () => ({ ...state, ...INITIAL_STATE })
  };

  return reducer[type] ? reducer[type]() : { ...state };
};

export default membershipReducer;
